import { useLanguageContext } from "../../../context/LanguageContext";
import VisitorPage from "../../../pages/visitors/visitor/VisitorPage";
import { useVisitorEditRouteValidator } from "../../validators/visitors/VisitorEditRouteValidator";
import { RouteConfig } from "../RouteConfig";
import useVisitorsRouteConfig from "./VisitorsRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useVisitorEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/visitors/:visitor/edit")
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.visitor"),
        },
      ])
    )
    .setValidator(useVisitorEditRouteValidator())
    .setPage(<VisitorPage />)
    .setParent(useVisitorsRouteConfig());
}

export default useVisitorEditRouteConfig;
